export const MOCK_PRODUCTION_FILM_DATA = {
  date: "2025-05-19",
  shift: "3",
  machine: "24",
  operator: "Operator-1",

  /* ================= TIMELINE PERIODS ================= */
  periods: [
    {
      start_min: 0,
      end_min: 60,
      reason: "Production",
      comment: ""
    },
    {
      start_min: 60,
      end_min: 90,
      reason: "Changeover",
      comment: "Die change"
    },
    {
      start_min: 90,
      end_min: 150,
      reason: "Production",
      comment: ""
    },
    {
      start_min: 150,
      end_min: 210,
      reason: "Breakdown",
      comment: "Hydraulic pressure low"
    },
    {
      start_min: 210,
      end_min: 270,
      reason: "Production",
      comment: ""
    },
    {
      start_min: 270,
      end_min: 300,
      reason: "Material Unavailable",
      comment: "Wire stock empty"
    },
    {
      start_min: 300,
      end_min: 360,
      reason: "Production",
      comment: ""
    },
    {
      start_min: 360,
      end_min: 390,
      reason: "People Unavailable",
      comment: "Operator break"
    },
    {
      start_min: 390,
      end_min: 450,
      reason: "Production",
      comment: ""
    },
    {
      start_min: 450,
      end_min: 480,
      reason: "Planned Stop",
      comment: "Shift end cleaning"
    }
  ],

  /* ================= PRODUCTION METRICS ================= */
  good_parts: 420,
  ideal_cycle_time: 18, // seconds
  running_hours: "07:12:00",
  part_number: "APTIV-0.5-TWB",

  /* ================= DECLARED HOURS ================= */
  stop_reasons_hours: {
    Changeover: 0.5,
    Breakdown: 1.0,
    "Material Unavailable": 0.5,
    "People Unavailable": 0.5,
    "Planned Stop": 0.5
  },

  /* ================= CALCULATED VALUES ================= */
  theoretical_hours: 2.1,
  oee: 78.35
};
